import { useLazyQuery, useMutation, useSubscription } from "@apollo/client";
import { Grid, TextField, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import Dialog from "components/Dialog";
import NavSwitcher, { TabProps } from "components/NavSwitcher";
import { Slider } from "components/Slider/Slider";
import Table from "components/Table";
import { ROW_PER_PAGE_OPTIONS } from "config";
import { DATE_FORMAT } from "config/constants";
import { SubtaskStatusList } from "constants/status";
import useText from "constants/text";
import { useAlertDispatch } from "contexts/AlertContext";
import { JobContext } from "contexts/JobContext";
import { subtaskReducer } from "data/actions/subtasks";
import { SubTaskActionType } from "data/types";
import { Slogan } from "domains/Task/components/Slogan/Slogan";
import { Job, SubTask, SubTaskStatus } from "generated/graphql";
import { useCurrentClient } from "hooks";
import moment from "moment";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "styled-components/macro";
import FilterGroup from "ui/Filter";
import { useJobColumnsRow } from "../Columns";
import { ShowTaskParcel, TaskDisplay } from "../components/home";
import { TaskModification } from "../components/home/TaskModification";
import { DeleteSubtaskPickupFromClient, TaskReschedules } from "../graphql/mutations";
import { JobByClientFromSubtask, SubTaskByStatusAndClientID } from "../graphql/queries";
import { SubtaskSuscribtions } from "../graphql/suscribtions";
import { useSubtaskActions } from "./data";
import { useStyles } from "./style";

const useTabs = (assigned = 0, unassigned = 0, completed = 0, to_reschedule = 0): TabProps[] => {
  const { text } = useText();
  return [
    {
      libelle: `${text.status.assigned}`,
      id: "assigned",
      count: assigned,
    },
    {
      libelle: `${text.status.unassigned}`,
      id: "unassigned",
      count: unassigned,
    },

    {
      libelle: `${text.status.completed}`,
      id: "completed",
      count: completed,
    },
    {
      libelle: `${text.status.to_reschedule}`,
      id: "to_reschedule",
      count: to_reschedule,
    },
  ];
};

const limit = 100;

export interface TaskProps {
  defaultTapvalue?: number;
  status: SubTaskStatus;
}
const useActions = () => {
  const { text } = useText();
  return [{ key: "1", label: text.all.date }];
};
export function Task({ defaultTapvalue = 0 }: TaskProps) {
  const styles = useStyles();
  const { text } = useText();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { client } = useCurrentClient();
  const [task, setTask] = useState<SubTask>(null);
  const [date, setDate] = useState(moment().format(DATE_FORMAT));
  const [status, setStatus] = useState<Array<string>>(SubtaskStatusList.UNASSIGNED);
  const JobColumnsRow = useJobColumnsRow();
  const [open, setOpen] = useState(false);
  const [isUpdate, update] = useState(false);
  const [deleteSubtaskPickupFromClient] = useMutation(DeleteSubtaskPickupFromClient);
  const [isDeleteSubTask, isToDeleteSubTask] = useState(false);
  const [toDeleteSubTask, setToDeleteSubTask] = useState<SubTask>(null);
  const [confirm, setConfirm] = useState(false);
  const [toReprogram, setToreprogram] = useState<SubTask>(null);
  const [key, setKey] = useState<string>(SubTaskStatus.Unassigned);
  const [isLoading, setIsloading] = useState(true);
  const [page, setPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const tabList = useTabs(totalCount, totalCount, totalCount);
  const actions = useActions();
  const [taskRechedules] = useMutation(TaskReschedules);
  const dispatchAlert = useAlertDispatch();
  const [formValues, setFormvalues] = useState(null);
  const jobContext = React.useContext(JobContext);
  const navigator = useNavigate();
  const subtaskActions = useSubtaskActions(text);

  const [querySubTaskByIClientID, { loading, refetch }] = useLazyQuery(SubTaskByStatusAndClientID, {
    onCompleted(data) {
      setTotalPage(data?.allSubTasksByClient.totalPages);
      setTotalCount(data?.allSubTasksByClient?.countTotal);
      setIsloading(false);
      dispatch({
        type: SubTaskActionType.FetchSubtask,
        data: data?.allSubTasksByClient?.data,
        statusKey: key,
      });
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  const [state, dispatch] = React.useReducer(subtaskReducer, {
    subtasks: {
      UNASSIGNED: [],
      ASSIGNED: [],
      DONE: [],
      TO_RESCHEDULE: [],
    },
  });
  useSubscription(SubtaskSuscribtions, {
    variables: { clientUID: client?._id },
    onSubscriptionData(options) {
      dispatch({
        type: SubTaskActionType.UpdateSubTask,
        data: options.subscriptionData.data.subtasks,
      });
    },
  });

  const [jobByClientFromSubtask] = useLazyQuery(JobByClientFromSubtask, {
    onCompleted(response) {
      const { code, message, data: job } = response?.jobByClientFromSubtask;
      if (code === 200 && job) {
        jobContext.setIsUpdateJob(true);
        jobContext.setDatePickup(job?.job_date);
        jobContext.setJob((prev: Job) => ({ ...job, job_date: moment().format("YYYY-MM-DD") }));
        navigator("/parcels/creations");
      } else {
        dispatchAlert({ severity: "error", message });
      }
    },
  });
  const updateSubtask = (subtask: SubTask) => {
    jobByClientFromSubtask({
      variables: {
        input: {
          subtaskId: subtask?._id,
        },
      },
    });
  };

  React.useEffect(() => {
    if (client) {
      setIsloading(true);
      querySubTaskByIClientID({
        variables: {
          params: { clientID: client?._id },
          queries: { status, date, limit },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client, date, status, page]);

  const openParcelsHandler = (t: SubTask) => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpenModal(false);
  };
  const openUpdateHandler = (t: SubTask) => {
    update(true);
  };
  const handleConfirm = (reprogram: { date: string; time: string }, t: SubTask) => {
    setToreprogram(t);
    setFormvalues(reprogram);
    update(false);
    setConfirm(true);
  };

  const handler = () => {
    taskRechedules({
      variables: {
        input: {
          subtaskID: toReprogram?._id,
          execution_date: formValues?.date,
          execution_slot_start: formValues?.time,
          execution_slot_end: formValues?.time === "11:00" ? "13:00" : "17:00",
        },
      },
    })
      .then((response) => {
        const { code, message } = response.data.subtaskReschedulingByClient;
        dispatchAlert({ severity: code === 200 ? "success" : "error", message });
      })
      .catch((error) => {
        dispatchAlert({ severity: "error", message: "Error from the server ..." });
      });
  };

  const deleteSubTask = (s: SubTask) => {
    setToDeleteSubTask(s);
    isToDeleteSubTask(true);
    setConfirm(true);
  };
  const doDeletionSubTask = () => {
    isToDeleteSubTask(false);
    deleteSubtaskPickupFromClient({
      variables: {
        input: { id: toDeleteSubTask?._id },
      },
    })
      .then((response) => {
        const { code, message: msg } = response.data?.deleteSubtaskPickupFromClient;
        dispatchAlert({ severity: code === 200 ? "success" : "warning", message: msg });
        refetch();
      })
      .catch(() => {});
  };

  const changePage = (newValue: number) => {
    setPage(newValue);
    setIsloading(true);
  };

  const onRowMenuClick = (key: string, row: any) => {
    switch (key) {
      case "edit":
        return updateSubtask(row);
      case "delete":
        return deleteSubTask(row);
      // no default
    }
  };

  const handleAction = (key: string) => {
    switch (key) {
      case "1":
        setOpenModal(true);
      // no default
    }
  };

  return (
    <div className={styles.root}>
      <Grid
        className={styles.left}
        style={{
          width: isSmallScreen ? "100%" : "75%",
        }}
      >
        <div className={styles.top}>
          <Slogan isTask />
        </div>
        <div className={styles.bottom}>
          <div className={styles.title}>
            <Typography
              css={`
                font-size: 24px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #1a224b;
              `}
            >
              {text.all.my_tasks}
            </Typography>

            <FilterGroup onClick={handleAction} actions={actions} />

            <Dialog
              title={text.all.filter_by_date}
              open={openModal}
              maxWidth="xs"
              handleConfirm={handleClose}
              handleClose={handleClose}
              confirmButtonTitle={text.all.validate}
              cancelButtonTitle={text.all.cancel}
            >
              <Grid container item spacing={4} direction="column" xs={12} className={styles.searchDate}>
                <Grid item xs={6}>
                  <TextField
                    type="date"
                    fullWidth
                    variant="outlined"
                    label={text.all.from}
                    name="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    type="date"
                    fullWidth
                    variant="outlined"
                    label={text.all.to}
                    name="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Dialog>
          </div>
          <Grid item xs={isSmallScreen ? 12 : 8}>
            <NavSwitcher
              withBadge
              onChange={(tab) => {
                setTask(null);
                setStatus(SubtaskStatusList[tab.id]);
                setKey(tab.id);
              }}
              tabs={tabList}
              defaultValue={defaultTapvalue}
            />
          </Grid>
          <div
            css={`
              height: 23rem;
              overflow-y: auto;
            `}
          >
            <div className={styles.table}>
              <Table
                data={state.subtasks[key]}
                rowsIdentifier="_id"
                columns={JobColumnsRow}
                isLoading={loading}
                onRowClick={(row) => {
                  setTask(row);
                }}
                isShowMenu
                statusKey={key}
                onRowMenuClick={onRowMenuClick}
                multipleActions={subtaskActions}
                advancedControl
                setRowsPerPage={setRowsPerPage}
                rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
                rowsPerPage={rowsPerPage}
                currentPage={page}
                countTotal={totalCount}
              />
            </div>
          </div>
        </div>
      </Grid>

      <Slider openDrawer={Boolean(task)} handleClose={() => setTask(null)}>
        <Grid item xs={4}>
          <TaskDisplay
            task={task}
            client={client}
            openParcelsHandler={openParcelsHandler}
            openUpdateHandler={openUpdateHandler}
          />
        </Grid>
      </Slider>
      <ShowTaskParcel open={open} handleClose={() => setOpen(false)} task={task} />
      <TaskModification open={isUpdate} handleClose={() => update(false)} task={task} handleConfirm={handleConfirm} />

      <Dialog
        title={text.all.confirmation}
        open={confirm}
        confirmButtonTitle={text.all.confirm}
        handleClose={() => setConfirm(false)}
        handleConfirm={() => {
          setConfirm(false);
          if (isDeleteSubTask) {
            doDeletionSubTask();
          } else {
            handler();
          }
        }}
      >
        {isDeleteSubTask ? text.all.sure_to_delete_task : text.all.sure_to_reschedule}
      </Dialog>
    </div>
  );
}

export default Task;
